import React, {useRef, useState} from 'react'
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogFormActions from "../shared/DialogFormActions";
import TextField from "@mui/material/TextField";
import {Box} from '@mui/material'
import DialogContent from '@mui/material/DialogContent'

function BackgroundFileCreate({backgroundFile, onClose, onSubmit}) {
    const [name, setName] = useState(backgroundFile ? backgroundFile.name : '');
    const [filePath, setFilePath] = useState(backgroundFile ? backgroundFile.filePath : '');
    const dialogRef = useRef(null);


    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({name, filePath});
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{backgroundFile ? 'Edit' : 'Create'} Background File</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                  autoFocus
                                  required
                                  margin="dense"
                                  id="name"
                                  label="Name"
                                  name="name"
                                  variant="standard"
                                  value={name}
                                  fullWidth
                                  onChange={e => setName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                  autoFocus
                                  required
                                  margin="dense"
                                  id="filePath"
                                  label="File Path"
                                  name="filePath"
                                  variant="standard"
                                  value={filePath}
                                  fullWidth
                                  onChange={e => setFilePath(e.target.value)}
                                />
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}
export default BackgroundFileCreate;
